<template>
  <div>
    <b-navbar toggleable="md" type="light" variant="light" class="px-0">

      
      <b-container>
        <b-navbar-brand href="#">
          專業成果/Results
        </b-navbar-brand>
      <b-navbar-toggle target="nav_collapse2"></b-navbar-toggle>
        <b-collapse is-nav id="nav_collapse2">

          <b-navbar-nav class="ml-auto" >
            <b-nav-item @click="setEmit(2)" :active="color===2">LED字幕機</b-nav-item>
            <b-nav-item @click="setEmit(3)" :active="color===3">LED電視牆</b-nav-item>
            <b-nav-item @click="setEmit(4)" :active="color===4">LED省電招牌</b-nav-item>
            <b-nav-item @click="setEmit(5)" :active="color===5">亮化工程</b-nav-item>
            <b-nav-item @click="setEmit(6)" :active="color===6">LED應用產品</b-nav-item>
            
          </b-navbar-nav>
        </b-collapse>
      </b-container>

    </b-navbar>

    <!-- navbar-1.vue -->

  </div>
</template>

<script>
export default {
  data(){
    return{
      emitdata:0,
      // colorArray:[true,false,false,false,false],
      color:2
    }
  },
  methods:{
    setEmit(num){
      this.emitdata=num;
      
      this.color=num;
      
      this.$emit('setEmit',this.emitdata);
    }
  }
}
</script>

<style lang="sass" scoped>
@import "~bootstrap/scss/bootstrap"

.active
  color: rgb(185, 40 , 45) !important


</style>








// WEBPACK FOOTER //
// src/components/NavBar2.vue